<ng-container *ngIf="!data.useNewStyles && !data.calledFrom">
  <div class="popup-main">
    <div class="title m-b-24" fxLayout="row" [ngClass]="{'warning-title': enableWarningSign}">
      <img class="warning-icon" src="/assets/dp-world-svgs/Warning.svg" *ngIf="enableWarningSign">
      <h1 [class]="data.useNewStyles ? 'new-title-style' : 'm-0'"
        [ngClass]="{'tabbed-layout-heading': data.useTabbedLayout}">{{data.title}}</h1>
      <!--<button mat-icon-button class="close-btn" (click)="closeClicked()">
      <mat-icon>close</mat-icon>
    </button>-->
    </div>
    <div *ngIf="data.commentInfo" fxLayoutAlign="space-between start">
      <div>{{data.commentInfo.commentBy}} added comment</div>
      <div>{{data.commentInfo.commentTime}}</div>
    </div>
    <div class="popup-contain" [ngClass]="{'d-block': data?.title === 'Mark CDD Review'}">
      <p [ngClass]="{'content-box': isGeneralContentDisplay}" class="desc">
        <ng-container *ngIf="getType(data.content) === 'object'">
          <p class="m-0">Upload below documents before create new finance</p><br>
          <ng-container *ngFor="let content of data.content">
            <ul>
              <li> {{content}}</li>
            </ul>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="getType(data.content) === 'string'">
          {{data.content}}
          <br>
          <ng-container *ngIf="data.title === 'Reject Credit Limit'">
            <mat-label>Reason</mat-label>
            <textarea autocomplete="off" style="width: 100%;" matInput maxlength="200" #reason
              placeholder="Ex. No longer require credit limit request"></textarea>
          </ng-container>
        </ng-container>
      </p>
      <ng-container *ngIf="data.title === 'Mark CDD Review'">
        <mat-form-field class="customize-field w-full" appearance="outline" fxFlex="100" fxLayoutAlign=" center">
          <mat-label>Review Date</mat-label>
          <input matInput placeholder="dd/mm/yyyy" [min]=data.minDate [max]=data.maxDate [matDatepicker]="picker"
            [formControl]="cddReviewDate" required>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </ng-container>
    </div>
    <div class="action-box p-b-4" [ngClass]="{'m-t-32': data.title !== 'Mark CDD Review'}" fxLayout="row wrap"
      [fxLayoutAlign]="fxBtnLayout">
      <ng-container *ngIf="isWarningNotification">
        <button class="comman-btn" [ngClass]="{'tabbed-layout-submit-btn': data.useTabbedLayout}" mat-button
          (click)="okayClicked()">Ok</button>
      </ng-container>
      <ng-container *ngIf="!isWarningNotification && !isGeneralContentDisplay">
        <button class="tertiary-btn m-t-4" [ngClass]="{'tabbed-layout-cancel-btn': data.useTabbedLayout}" mat-button
          mat-dialog-close (click)="closeClicked()">{{data.closeBtn ?
          data.closeBtn: 'Close'}}</button>
        <button class="comman-btn m-t-4" [ngClass]="{'tabbed-layout-submit-btn': data.useTabbedLayout}" mat-button
          (click)="saveClicked()"
          [disabled]="data?.title === 'Mark CDD Review' && cddReviewDate?.invalid">{{data.submitButton}}</button>
      </ng-container>
      <ng-container *ngIf="isGeneralContentDisplay">
        <button class="tertiary-btn m-t-4" [ngClass]="{'tabbed-layout-cancel-btn': data.useTabbedLayout}" mat-button
          mat-dialog-close (click)="closeClicked()">Close</button>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="data.useNewStyles">
  <div fxLayout="column" class="p-32">
    <div class="heading"> {{ data.title}}</div>
    <div class="subHeading p-t-8"> {{ data.content}}</div>
    <mat-form-field class="comment-box p-t-16" appearance="fill" fxFlex="100">
      <mat-label>Comments</mat-label>
      <input matInput autocomplete="off" maxlength="200" [(ngModel)]="comments">
    </mat-form-field>
  </div>

  <div class="footer p-x-16" fxLayout="row wrap" [fxLayoutAlign]="fxBtnLayout">
    <span class="p-t-8 p-b-8" fxLayoutAlign="space-between end" fxFlex="100">
      <span></span>
      <span>
        <button class='basic-button secondary-button' [ngClass]="{'tabbed-layout-cancel-btn': data.useTabbedLayout}"
          mat-button mat-dialog-close (click)="closeClicked()">Cancel</button>
        <button class="basic-button m-l-16"
          [ngClass]="data.submitButton.includes('Reject') ? 'reject-button' : 'primary-button'" mat-button
          [ngClass]="{'tabbed-layout-submit-btn': data.useTabbedLayout}"
          (click)="saveClicked()">{{data.submitButton}}</button>
      </span>
    </span>
  </div>
</ng-container>

<ng-container *ngIf="data.calledFrom === 'bhsFinancePage'">
  <div class="bhs">
    <div class="p-16 heading-box"> {{ data.title}}</div>
    <div fxLayout="column" class="p-x-16">
      <div class="content"> {{ data.content}}</div>
      <div class="subContent"> {{ data.subContent}}</div>

      <mat-form-field class="customize-field p-y-16 remarks-area" appearance="fill" fxFlex="100">
        <textarea maxlength="5000" rows="3" matInput type="text" [(ngModel)]="comments"
          placeholder="Add your remarks here"></textarea>
      </mat-form-field>
    </div>

    <div class="p-x-16" fxLayout="row wrap" [fxLayoutAlign]="fxBtnLayout">
      <span class="p-b-8" fxLayoutAlign="space-between end" fxFlex="100">
        <span></span>
        <span>
          <button class='bhs-button bhs-secondary-button' mat-button mat-dialog-close (click)="closeClicked()"
            [ngClass]="{'tabbed-layout-cancel-btn': data.useTabbedLayout}">Cancel</button>
          <button class="bhs-button m-l-16 bhs-primary-button" mat-button (click)="saveClicked()"
            [ngClass]="{'tabbed-layout-submit-btn': data.useTabbedLayout}">{{data.submitButton}}</button>
        </span>
      </span>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="data.v2Styles">
  <div fxLayout="column">
    <div class="heading-v2"> {{ data.title}}</div>
    <div class="subHeading-v2 p-t-8"> {{ data.content}}</div>
    <ng-container class="comment-box-v2">
      <mat-label class="comment-label-v2">Comments</mat-label>
      <mat-form-field appearance="outline" fxFlex="100">
        <textarea matInput autocomplete="off" maxlength="200" [(ngModel)]="comments"></textarea>
      </mat-form-field>
    </ng-container>
  </div>
  <div class="footer p-x-16" fxLayout="row wrap" [fxLayoutAlign]="fxBtnLayout">
    <span class="p-t-8 p-b-8" fxLayoutAlign="space-between end" fxFlex="100">
      <span></span>
      <span>
        <button class='basic-button secondary-button tabbed-layout-cancel-btn' mat-button mat-dialog-close
          (click)="closeClicked()">Cancel</button>
        <button class="basic-button m-l-16 primary-button tabbed-layout-submit-btn" mat-button
          (click)="saveClicked()">{{data.submitButton}}</button>
      </span>
    </span>
  </div>
</ng-container>